import React, { useState } from 'react';
import "./OfferPage.css";
import logo from "assets/logo.png";
import logo3 from "assets/logo3.png"
import logo4 from "assets/logo4.png"
import logo5 from "assets/logo5.png"
import logo6 from "assets/logo6.png"
import logo8 from "assets/logo8.png"
import logo9 from "assets/logo9.png"
import logo10 from "assets/logo10.png"
import prLogo from "assets/pr.png";
import capcutLogo from "assets/capcut.png";
import davLogo from "assets/dav.png";
import iphoneLogo from "assets/iphone.png";
import djiLogo from "assets/dp.png";
import finalLogo from "assets/final.png";

import {   CourseBundleSection, FAQSection, FooterSection, GuaranteeSection, PricingSection,  StorySection, StudentsResultsSection, TermsSection, ClientsSaySection } from 'components';
// Add these imports:
import Header from '../../components/Header';
import { useNavigate } from 'react-router-dom';

const brandLogos = [
  { src: logo6, alt: "Logo 1" },
  { src: logo8, alt: "Logo 3", className: "logo8-img" },
  { src: logo9, alt: "Logo 4" },
  { src: logo10, alt: "Logo 5" },
  { src: logo3, alt: "Logo 7" },
  { src: logo4, alt: "Logo 8" },
  { src: logo5, alt: "Logo 9" },
];

const OfferPage = () => {
  // const [modalOpen, setModalOpen] = useState(false); // Remove modal state
  const navigate = useNavigate();

  return (
    <div className="main-page">
      {/* Header with Login button */}
      <Header onLoginClick={() => navigate('/login-signup')} />
      {/* Remove <LoginSignupModal open={modalOpen} onClose={() => setModalOpen(false)} /> */}
      {/* Top Black Banner */}

      {/* Main Content */}
      <div className="content-section">
        <div className="left-content">
          <div className="main-logo-wrapper">
            <img src={logo} alt="Logo" className="main-logo" />
          </div>
          <h1 className="main-heading">
            7 Step Guide To Making Viral Social Media Content
          </h1>
          <div
            className="find-out"
            style={{ background: '#f4c542', padding: '12px 24px', borderRadius: 8, margin: '0 0 24px 0', display: 'inline-block', fontWeight: 600, fontSize: '1.2rem', cursor: 'pointer' }}
            onClick={() => {
              const el = document.getElementById('pricing');
              if (el) el.scrollIntoView({ behavior: 'smooth' });
            }}
          >
            Find out how!
          </div>
        </div>
        <div className="right-content" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <video
            className="hero-video"
            src="/media/landing.mp4"
            controls
            autoPlay
            loop
            muted
            style={{ width: '100%', maxWidth: 600, borderRadius: 16,  }}
          />
        </div>
      </div>

      {/* Bottom Black Banner */}
      
      {/* Auto-scrolling logo section */}
      <div className="brand-section">
        <div className="brand-heading">
          Generated over £250,000,000 in sales for these brands
        </div>
        <div className="logo-marquee">
          <div className="logo-container">
            {/* Repeat logos 3 times for smooth infinite scroll */}
            {[0,1,2].map(loopIdx => (
              brandLogos.map((logoObj, i) => (
                <img
                  key={`logo-${loopIdx}-${i}`}
                  src={logoObj.src}
                  alt={logoObj.alt}
                  className={logoObj.className || ''}
                />
              ))
            ))}
          </div>
        </div>
      </div>
      {/* <ReviewSection /> */}
      <StorySection />
      <StudentsResultsSection />
      <ClientsSaySection />
      {/* <BonusSection /> */}
      <div className="tools-banner-section">
        <div className="tools-banner-heading">Tools we use</div>
        <div className="tools-logo-row">
          <img src={prLogo} alt="Premiere Pro" className="tool-logo" />
          <img src={capcutLogo} alt="CapCut" className="tool-logo" />
          <img src={davLogo} alt="DaVinci Resolve" className="tool-logo" />
          <img src={iphoneLogo} alt="Apple" className="tool-logo" />
          <img src={djiLogo} alt="DJI" className="tool-logo" />
          <img src={finalLogo} alt="Final Cut Pro" className="tool-logo" />
        </div>
      </div>
      <CourseBundleSection />

      <PricingSection />
      {/*  */}
      <GuaranteeSection />
      <FAQSection />
      <TermsSection />
      <FooterSection />
    </div>
  )
}

export default OfferPage

// ProofSection, ReviewSection,